import styled from "styled-components"

export interface StyledTableProps {
    vertical_headings: boolean
}
export const StyledTableContainer = styled.div`
    overflow-x: scroll;
    width: 100%;
    @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
        width: calc(100% + 48px);
        margin-left: -24px;
    }
    @media (max-width: ${(props) => props.theme.breakPoints.mobile}) {
        width: calc(100% + 32px);
        margin-left: -16px;
    }
`
export const StyledTable = styled.table<StyledTableProps>`
    width: 100%;
    table-layout: fixed;

    & tr{
        border-bottom: 1px solid ${props => props.theme.colors.darkGrey20};
    }
    & th, & td{
        vertical-align: middle;
        @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
            width: calc((${(props) => props.theme.breakPoints.tablet} / 3) - 48px);
        }
        @media (max-width: ${(props) => props.theme.breakPoints.mobile}) {
            width: calc((${(props) => props.theme.breakPoints.mobile} / 2) - 32px);
        }
        padding: 24px;
        @media (max-width: ${(props) => props.theme.breakPoints.mobile}) {
            padding: 24px 16px;
        }
        ${props => props.theme.mixins.body}
        text-align: left;
        color: ${props => props.theme.colors.darkGrey};
        
        &:nth-of-type(even){
            background: ${props => props.theme.colors.ivoryShadow3};
        }
        &:nth-of-type(odd){
            background: ${props => props.theme.colors.ivoryShadow2};
        }
    } 
    & th{
        ${props => props.theme.mixins.bold}
        font-size: 18px;
        line-height: 22px;
        white-space: pre-line;
    } 

    ${props => props.vertical_headings && `
        & tr{
            & td:nth-of-type(1), & th:nth-of-type(1){
                ${props.theme.mixins.bold}
                font-size: 18px;
                line-height: 22px;
                background: ${props.theme.colors.white};
                @media (max-width: ${props.theme.breakPoints.tablet}) {
                    position: sticky;
                    left: 0;
                }
            }
        }
    `}
`
